import { render } from "./tender_files.vue?vue&type=template&id=397b2972"
import script from "./tender_files.vue?vue&type=script&lang=js"
export * from "./tender_files.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tabs/tender_files.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "397b2972"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('397b2972', __exports__)) {
    console.log('reload')
    api.reload('397b2972', __exports__)
  }
  
  module.hot.accept("./tender_files.vue?vue&type=template&id=397b2972", () => {
    console.log('re-render')
    api.rerender('397b2972', render)
  })

}


export default __exports__